module.exports = __webpack_public_path__ + "static/media/job-post-3.a1d1e2cb.svg";